import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const QtyProduct = ({
    qty: initialQty = 0,  // تغییر مقدار پیش‌فرض به صفر
    setQty: externalSetQty, // Optional function provided by parent for setting quantity
    minQty = 0, // تغییر مقدار حداقل به صفر
    maxQty = 10,
    steps = 1,
    isReadOnly = true,
    pageLanguage,
    NumberToPersianWord,
    handleIncrement,
    handleDecrement,
    handleInputChange
}) => {

    // Internal state for quantity
    const [internalQty, setInternalQty] = useState(initialQty);
    const { i18n } = useTranslation();

    useEffect(() => {
        setInternalQty(initialQty);
    }, [initialQty]);

    const internalHandleIncrement = () => {
        if (internalQty < maxQty) {
            const newQty = internalQty + steps;
            setInternalQty(newQty);
            if (externalSetQty) externalSetQty(newQty); // Call external function if provided
            if (handleIncrement) handleIncrement(steps); // Call external increment handler if provided
        }
    };

    const internalHandleDecrement = () => {
        if (internalQty > minQty) {
            const newQty = internalQty - steps;
            setInternalQty(newQty);
            if (externalSetQty) externalSetQty(newQty); // Call external function if provided
            if (handleDecrement) handleDecrement(parseFloat(0 - steps)); // Call external decrement handler if provided
        }
    };

    const internalHandleInputChange = (e) => {
        let value = NumberToPersianWord.convertPeToEn(e.target.value);
        value = parseInt(value, 10);

        if (isNaN(value)) {
            return; // Ignore if the input is not a number
        }

        // Ensure value is within the allowed range
        if (value < minQty) {
            value = minQty;
        } else if (value > maxQty) {
            value = maxQty;
        }

        setInternalQty(value);
        if (externalSetQty) externalSetQty(value); // Call external function if provided
        if (handleInputChange) handleInputChange(value); // Call external input change handler if provided
    };

   
     const formatQuantity = () => {
        return new Intl.NumberFormat(i18n.language === "en" ? "en-US" : "fa-IR").format(internalQty);
    };
    return (
        <div className="basket_item_qty_numbers Qty-input">
            <button
                type="button"
                className="basket_qty_minus"
                onClick={internalHandleDecrement}
                disabled={internalQty <= minQty} // Disable button when qty is at min limit
            >
                <img
                    src={require('../Images/public/minus.svg').default}
                    alt=""
                    className="qty_math_icon img-fluid"
                />
            </button>
            <input
                type="text"
                className="basket_qty_num"
                value={formatQuantity()}
                onChange={isReadOnly ? null : internalHandleInputChange} // Conditionally allow changes
                readOnly={isReadOnly} // Set the input field as read-only based on the prop
            />
            <button
                type="button"
                className="basket_qty_plus"
                onClick={internalHandleIncrement}
                disabled={internalQty >= maxQty} // Disable button when qty is at max limit
            >
                <img
                    src={require('../Images/public/plus.svg').default}
                    alt=""
                    className="qty_math_icon img-fluid"
                />
            </button>
        </div>
    );
};

export default QtyProduct;
